module.exports = __webpack_public_path__ + "img/f6cbfb0.jpg";